import { useTranslation } from '@wix/yoshi-flow-editor';

import { useOnlineOrdersStorage } from '../../storage';
import { useGetLayoutSize } from '../../../../components-shared/LayoutSizeProvider';

export const useHooks = () => {
  const { t } = useTranslation();
  const { layoutSize } = useGetLayoutSize();

  const {
    dispatchesInfo,
    operations,
    currentOperation,
    isLocationSelected,
    selectedDispatchType,
    acceptingDispatchTypesByOperationId,
    openFulfillmentModal,
  } = useOnlineOrdersStorage();

  const handleClick = () => {
    if (!currentOperation) {
      return;
    }

    openFulfillmentModal({
      operations,
      currentOperation,
      dispatchesInfo,
      selectedDispatchType,
      acceptingDispatchTypesByOperationId,
      forceLocationSelection: operations.length > 1 && !isLocationSelected,
    });
  };

  return {
    t,
    layoutSize,
    handleClick,
  };
};
